import React from "react";

interface FeatureCardProps {
    title: string;
    description: string;
    imgSrc: string;
    imgSrcMobile: string;
}

export function FeatureCard(props: FeatureCardProps) {
    const { title, description, imgSrc, imgSrcMobile } = props;

    return (
        <div className="feature-card d-flex flex-column-reverse flex-md-row gap-4 align-items-stretch">
            <div className="text-content flex-grow-1 text-start my-auto">
                <h3 className="feature-card-header mb-2">{title}</h3>
                <p className="feature-card-paragraph mb-0">{description}</p>
            </div>
            <div className="feature-icon-wrapper">
                <picture>
                    <source media="(min-width: 768px)" srcSet={imgSrc} />
                    <img 
                        alt="" 
                        className="feature-pic" 
                        src={imgSrcMobile} 
                    />
                </picture>
            </div>
        </div>
    );
}
